module.exports = __webpack_public_path__ + "static/media/shirt.203601fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cart/shirt.png
// module id = 157
// module chunks = 0